import { Injectable } from '@angular/core';

@Injectable()
export class InputPatternService {
  public safeASCII = {
    pattern: /[\x20\x22-\x24\x26-\x29\x3D\x2B-\x3B\x40-\x5A\x5E-\x7A\x7E\x80-\xFF]/
  };
}
